import React, { useState } from 'react'
import { Button, Form, Modal } from 'react-bootstrap'
import { useAtomValue, useSetAtom } from 'jotai'

import * as lib from '../../lib'
import * as state from '../../states'
import { IRevenueSpend } from '../../types'
import { useSearchParams } from 'react-router'
import { useTranslation } from 'react-i18next'
import { ALL_LANG_KEY } from '../../types/lang'

type IRevenueSpendEditNotesModalProps = {
	item: IRevenueSpend | null;
	show: boolean;
	onClose: () => void;
	onSave: () => void;
	isViewMode?: boolean;
}

export const RevenueSpendEditNotesModal = (
	props: IRevenueSpendEditNotesModalProps
) => {
	const { t } = useTranslation()
	const setFetchIsLoading = useSetAtom(state.fetchIsLoadingAtom)
	const [searchParams] = useSearchParams()
	const tokens = useAtomValue(state.tokensAtom)
	const access = tokens?.access ?? null

	const { item, show, onClose, onSave, isViewMode = false } = props

	const [notes, setNotes] = useState<string>(item?.notes ?? '')
	const [prevNotes, setPrevNotes] = useState<string>(item?.notes ?? '')

	if (!show) {
		return null
	}

	const onUpdate = async () => {
		const uri: string = `revenue/spend/${item?.id}`
		const method: string = 'PATCH'
		const params: lib.FetchOptions['params'] = {}
		const headers = lib.bearer(access)
		const body: string = JSON.stringify({
			notes
		})
		const options: lib.FetchOptions = { body, method, params, headers }

		try {
			setFetchIsLoading(state.turnOnLoader)
			await lib.fetching<void>(uri, options)
			setPrevNotes(notes)
			onSave()
		} catch (error: unknown) {
			// TODO: pretty notification alert
			console.error(error)
		} finally {
			setFetchIsLoading(state.turnOffLoader)
		}
	}

	const modalTitle = `${t(isViewMode ? ALL_LANG_KEY.revenue_spend_crud_modal.title_notes_view : ALL_LANG_KEY.revenue_spend_crud_modal.title_notes_edit)} #${item?.id}`

	return <>
		<Modal show={show} onHide={onClose} className={'edit-notes-modal scroll'}>
			<Modal.Header closeButton>
				<Modal.Title>{modalTitle}</Modal.Title>
			</Modal.Header>

			<Modal.Body>
				<Form>
					<Form.Group>
						<Form.Label className="text-dark" htmlFor={`input-notes-${item?.id}`}>{`${t(ALL_LANG_KEY.revenue_spend_crud_modal.field_notes_label)}`}</Form.Label>
						<textarea name="notes"
						          id={`input-notes-${item?.id}`}
						          className={'form-control textarea-field'}
						          value={notes}
						          disabled={isViewMode}
						          onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setNotes(e.target.value)}
						/>
					</Form.Group>
				</Form>
			</Modal.Body>

			<Modal.Footer>
				{
					!isViewMode ? (
						<Button variant="primary"
						        onClick={onUpdate}
						        disabled={prevNotes === notes}
						>
							{`${t(ALL_LANG_KEY.revenue_spend_crud_modal.btn_update)}`}
						</Button>
					) : null
				}

				<Button variant="secondary" onClick={onClose}>{`${t(ALL_LANG_KEY.revenue_spend_crud_modal.btn_close)}`}</Button>
			</Modal.Footer>
		</Modal>
	</>
}
